module.exports = __webpack_public_path__ + "img/degen.3eb21f92.png";